import { useEffect, useRef } from "react";
import { useTheme } from "../../components/Layout/ThemeContext/ThemeContext";
import "react-tooltip/dist/react-tooltip.css";
import { useAuth } from "../../Providers/AuthProvider/AuthProvider";
import config from '../../components/Common/config'; // Import your config file
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";

const loadAttachments = async () => {
    const allMediaItems = []; // Array to store media items from all layers
  
    for (const layerConfig of config.featureServices) {
      const layer = new FeatureLayer({
        url: layerConfig.url,
        outFields: ["*"],
      });
  
      try {
        const query = layer.createQuery();
        query.where = "Isadminapproved!=2";
        query.returnGeometry = true;
        query.outFields = ["*"];
        const results = await layer.queryFeatures(query);
  
        const objectIds = results.features.map(
          (feature) => feature.attributes.OBJECTID
        );
        const attachments = await layer.queryAttachments({ objectIds });
  
        results.features.forEach((feature) => {
          const objectId = feature.attributes.OBJECTID;
  
          if (attachments[objectId] && attachments[objectId].length > 0) {
            attachments[objectId].forEach((attachment) => {
              if (
                attachment.contentType.startsWith("image/") ||
                attachment.contentType.startsWith("video/") ||
                attachment.contentType.startsWith("audio/")
              ) {
                const mediaItemObject = {
                  type: attachment.contentType,
                  url: attachment.url,
                  objectId: objectId,
                  layerName: layerConfig.name,
                  addPOIName:feature.attributes.name_en
                };
                allMediaItems.push(mediaItemObject);
              }
            });
          }
        });
      } catch (error) {
        console.error(
          `Error querying layer "${layerConfig.name}" or attachments:`,
          error
        );
      }
    }
    
    return allMediaItems.length > 0 ?{Media:allMediaItems,status:true}:{Media:allMediaItems,status:false}; // Return the data
  };
  
  export default loadAttachments;
